import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { AssetRegisterModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[AssetRegister] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[AssetRegister] Load items success', props<{ data: PaginationAdapter<AssetRegisterModel> }>());

// item
export const loadItem = createAction('[AssetRegister] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[AssetRegister] Load item success', props<{ item: AssetRegisterModel }>());
